/**
 * @description ARMS埋点策略 - 集中配置管理方案
 * @author zcq
 * @date 2025-04-18
 */

import { BaseBurialPointStrategy } from './base-strategy';
import { EEnvironment, IStrategyConfig } from '../types';
// write by cursor
/**
 * ARMS埋点策略实现
 */
export class ArmsStrategy extends BaseBurialPointStrategy {
  private ArmsRum: any;

  constructor(
    private config: IStrategyConfig,
    private environment: EEnvironment
  ) {
    super();
  }

  // 动态加载ARMS SDK
  private async loadArmsSDK(): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        // 检查是否已经加载
        if (window.__rum) {
          this.ArmsRum = window.RumSDK?.default;
          resolve();
          return;
        }

        // 设置ARMS配置
        window.__rum = {
          ...this.config,
          env: this.environment
        };

        // 创建脚本标签
        const script = document.createElement('script');
        script.src = this.config.sdkUrl;
        script.crossOrigin = '';
        script.onload = () => {
          this.ArmsRum = window.RumSDK?.default;
          resolve();
        };
        script.onerror = (error) => {
          reject(error);
        };

        // 添加到文档
        document.body.insertBefore(script, document.body.firstChild);
      } catch (error) {
        reject(error);
      }
    });
  }

  async init(): Promise<void> {
    if (this.initialized) return;

    await this.withRetry(
      async () => {
        await this.loadArmsSDK();
        if (this.ArmsRum) {
          this.initialized = true;
          console.log(`berry SDK 初始化成功 (环境: ${this.environment})`);
        } else {
          throw new Error("berry SDK 未找到");
        }
      },
      "berry 初始化失败"
    );
  }

  sendEvent(eventType: string, eventName: string, params?: Record<string, any>): void {
    if (!this.initialized || !this.ArmsRum) return;

    try {
      // 拼接事件类型和名称
      const fullEventName = `${eventType}_${eventName}`;

      // 使用 ARMS 的 sendCustom 方法发送自定义事件
      this.ArmsRum.sendCustom({
        type: "CustomEvent",
        name: fullEventName,
        value: 1,
        group: this.config.group || 'default-group',
        // 添加自定义参数
        ...params,
      });
    } catch (error) {
      console.error("send event to ARMS failed:", error);
    }
  }
}
